import React, { useCallback, useEffect, useState } from "react";
import FormField from "../form-field";

const defaultAwards = {
    nameOfAward: "",
    issuedBy: "",
    awardDate: "",
    expiryDate: "",
    certification: "",
    certificationBody: "",
    certificateExpiryDate: "",
};

const Awards = ({ data, onDataChange }) => {
  const [form, setForm] = useState({ ...defaultAwards, ...(data || {}) });

  useEffect(() => {
    onDataChange?.(form);
  }, [form, onDataChange]);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }, []);
  return (
    <div>
      <p className=" text-2xl my-2">Awards</p>

      <form action="">
        <div className=" grid lg:w-[75%] grid-cols-1 md:grid-cols-2 gap-4 ">
          <FormField
            label="Name of Award"
            placeholder="Award"
            id="nameOfAward"
            name="nameOfAward"
            onChange={handleChange}
            value={form.nameOfAward}
          />

          <FormField
            label="Issued By"
            placeholder="Issuing Company"
            id="issuedBy"
            name="issuedBy"
            onChange={handleChange}
            value={form.issuedBy}
          />

          <FormField
            label="Award Date"
            id="awardDate"
            name="awardDate"
            type="date"
            onChange={handleChange}
            value={form.awardDate}
          />

          <FormField
            label="Expiry date (leave blank if not applicable)"
            id="expiryDate"
            name="expiryDate"
            type="date"
            onChange={handleChange}
            value={form.expiryDate}
          />
        </div>
        <p className=" text-2xl my-4">Certifications</p>

        <div className="grid lg:w-[75%] grid-cols-1 md:grid-cols-2 gap-4 ">
          <FormField
            label="Certification"
            id="certification"
            name="certification"
            placeholder="Certification"
            onChange={handleChange}
            value={form.certification}
          />

          <FormField
            label="Issuing Body"
            id="certificationBody"
            name="certificationBody"
            placeholder="Issuing body"
            onChange={handleChange}
            value={form.certificationBody}
          />

          <FormField
            type="date"
            label="Expiry date (leave blank if not possible)"
            id="certificationExpiryDate"
            name="certificationExpiryDate"
            value={form.certificateExpiryDate}
            onChange={handleChange}
          />
        </div>
      </form>
    </div>
  );
};

export default Awards;
